import { atom } from 'recoil'
import { FireBaseUser } from '../firebase'

export const authUserState = atom<{
  user: FireBaseUser
  isAuthRequested: boolean
}>({
  key: 'authUser',
  default: {
    user: null,
    isAuthRequested: false,
  },
  dangerouslyAllowMutability: true,
})

export const idTokenState = atom<{ idToken: string | undefined; isTokenRequested: boolean }>({
  key: 'idToken',
  default: {
    idToken: undefined,
    isTokenRequested: false,
  },
})

// リクエストが完了したかどうか（主に無限ローディング回避に利用）
export const idTokenRequestState = atom<boolean>({
  key: 'status',
  default: false,
})

export const requestState = atom<{
  isLoading?: boolean
  completeMessage?: string
  errorMessage?: string
}>({
  key: 'request',
  default: { isLoading: false, completeMessage: '', errorMessage: '' },
})
